export const SITE_URL = 'https://ailivesim.com';
export const SITE_NAME = 'AILiveSim';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/og/default-1200x630.webp`;
export const DEFAULT_OG_IMAGE_TYPE = 'image/webp';
export const DEFAULT_LOCALE = 'en_US';
// Intentionally empty: AILiveSim has no X/Twitter account.
// When left empty, MetaHead omits the twitter:site tag (other twitter:* tags
// still render). Set to '@handle' if an account is created.
export const TWITTER_HANDLE = '';
